import React, { Fragment, useEffect, useRef, useState } from "react";
import { interlocutorForm } from "./data";
import { useTranslation } from "react-i18next";
import Interlocutor from "./Interlocutor";
import { isDefined } from "../../../Utils";

import userPhoto from "../../../Images/Images/avatar.png";
import { IMAGE_END_POINT } from "../../../Api/EndPoints";

const Interlocutors = ({
  initialValues = [],
  handleFormChange = () => {},
  updateDeletedInterlocutors,
}) => {
  const fileInputRef = useRef([]);
  const { t } = useTranslation("common");
  const [formData, setFormData] = useState(initialValues);

  const getSelectValue = (value, options) => {
    if (typeof value === "object") {
      return value;
    }
    const currentOption = options.find((option) => option.code === value);
    if (currentOption) {
      return {
        name: t(`${currentOption.name}`),
        code: currentOption.code,
      };
    }
    return {};
  };

  const addNewElement = () => {
    setFormData((prev) => [...prev, {}]);
  };

  const handleChange = (index) => (e) => {
    const { value, name } = e.target;
    setFormData((prev) => {
      const updatedFormData = [...prev];
      updatedFormData[index] = {
        ...updatedFormData[index],
        [name]: value,
      };
      return updatedFormData;
    });
  };

  const handleDelete = (index, interlocutor) => () => {
    if (isDefined(interlocutor?.id)) {
      updateDeletedInterlocutors((prev) => [...prev, interlocutor]);
    }
    setFormData((prev) => {
      const updatedFormData = [...prev];
      updatedFormData.splice(index, 1);
      return updatedFormData;
    });
  };

  const handleClick = (index) => {
    fileInputRef.current[index].click();
  };

  const handleImageChange = (index) => (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      setFormData((prev) => {
        const updatedFormData = [...prev];
        updatedFormData[index] = {
          ...updatedFormData[index],
          photo: imageFile,
        };
        return updatedFormData;
      });
    }
  };

  useEffect(() => {
    handleFormChange("interlocutors", formData);
  }, [formData]);

  return (
    <div className="flex-1 d-flex flex-column">
      <div className="modalContent px-5 pt-4 pb-5 d-flex flex-column">
        {formData.map((interlocutor, index) => {
          let photo = userPhoto;
          if (interlocutor.photo instanceof File) {
            photo = URL.createObjectURL(interlocutor.photo);
          } else if (interlocutor.photo) {
            photo = `${IMAGE_END_POINT}${interlocutor.photo.attributes.url}`;
          }
          return (
            <>
              <div className="d-flex gap-3">
                <div className="">
                  <div className="me-4 d-flex justify-content-center align-self-lg-start position-relative pointer">
                    <label htmlFor="imageInput" className="imageInput">
                      <img
                        src={photo}
                        alt="Prospect"
                        className="br50 ob-cover w100 h100 pointer"
                        onClick={() => handleClick(index)}
                      />
                    </label>
                    <input
                      ref={(ref) => (fileInputRef.current[index] = ref)}
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange(index)}
                      hidden
                    />
                    <div className="iconContainer d-flex align-items-center justify-content-center bg-softBlue br50 size-40px mt-auto">
                      <i
                        className="bi bi-camera text-white f18"
                        onClick={() => handleClick(index)}
                      />
                    </div>
                  </div>
                </div>
                <div className="row gy-2">
                  {interlocutorForm.map((el) => (
                    <Fragment key={el?.name}>
                      <Interlocutor
                        el={el}
                        index={index}
                        interlocutor={interlocutor}
                        handleChange={handleChange}
                        getSelectValue={getSelectValue}
                      />
                    </Fragment>
                  ))}
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button
                  className="d-flex align-items-center justify-content-center border-0 px-2 py-1 br5 bg-dimGrey"
                  onClick={handleDelete(index, interlocutor)}
                >
                  <i className="bi bi-trash" />
                </button>
              </div>
              <hr
                style={{ borderColor: "#abb8b2", margin: 0 }}
                className="my-4"
              />
            </>
          );
        })}
        <div
          className="br5 w-50 cursor-pointer shadow alignC p-2 pb-4"
          onClick={addNewElement}
        >
          <div className="w-50 alignC flex-column h100 bold text-center">
            <i className="bi bi-plus f50 text-brightGrey"></i>
            <span className="f14 text-brightGrey">
              {t("Add interlocutor")}{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Interlocutors;
